import messageEnums from 'enums/messages';

export default function fromSmoochMessage(message) {
  let content, secureOrgId, vaultId;
  if (message.type === messageEnums.TYPES.TEXT) {
    if (message.metadata.subType === messageEnums.SUB_TYPES.CREDIT_CARD_REQUEST) {
      content = {
        currency: message.metadata.currency,
        monetaryUnit: message.metadata.monetaryUnit,
        memo: message.metadata.memo,
        status: message.metadata.requestStatus,
        paymentId: message.metadata.itemId,
      };
      secureOrgId = message.metadata.secureOrgId;
      vaultId = message.metadata.vaultId;
    } else {
      content = { body: message.text };
    }
  } else if (message.type === messageEnums.TYPES.IMAGE || message.type === messageEnums.TYPES.FILE) {
    content = {
      fileName: message.metadata.fileName,
      mediaUrl: message.mediaUrl,
    };
  } else {
    return;
  }
  return {
    attachmentId: message.metadata.attachmentId || '',
    id: message.metadata.internalId || message._id,
    content,
    date: new Date(message.received * 1000),
    isUser: message.role === 'appUser',
    gladlyCustomerId: message.metadata.gladlyCustomerId,
    secureOrgId: secureOrgId,
    subType: message.metadata.subType,
    vaultId: vaultId,
    // initial states; errors are added by createMessage.js if an error comes in
    _isSending: false,
    _hasError: false,
    _errors: [],
  };
}
